module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"reviews_count":"评价 {count}"}}')
  delete Component.options._Ctor
}
